import { Link } from "react-router-dom";

const RecommendGenres = ({ currentTab, genresList }) => {

  const getFavouriteGenresIds = () => {
    const myFavouriteMovieGenresIds = [12, 28, 878, 35, 53, 9648, 10749];
    const myFavouriteTVGenresIds = [10765, 10759, 16, 18, 37, 9648];
    return currentTab === "movie"
      ? myFavouriteMovieGenresIds
      : myFavouriteTVGenresIds;
  };

  const favouriteGenresIds = getFavouriteGenresIds();

  return (
    <ul className="mt-28 flex gap-3 flex-wrap ">
      {favouriteGenresIds.map((genreId) => (
        <li key={genreId} className="mb-2">
          <Link
            to={`/explore?genre=${String(genreId)}`}
            className="px-4 py-2 mr-2 mb-5 rounded-full tw-shaded-button text-sm transition duration-300 
                      hover:shadow-md hover:shadow-gray-darken hover:text-white"
          >
            {genresList[genreId]}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default RecommendGenres;
